
















































import Vue from 'vue'
import moment from 'moment'
import request from '@/utils/request'
import videoPlayer from './videoPlayer.vue'
import pdfView from './pdf_view.vue'
import { Toast } from 'vant'
import sha1 from 'sha1'
import { WECHAT_APPID,WECAHT_NAME,IMG_URL } from '@/utils/constants'
import { wxShare } from '@/utils/wxApi'
export default Vue.extend({
  components: { videoPlayer, pdfView },
  data() {
    return {
      id: '' as any,
      data: {},
      font_type: 'middle',
      
      liked: 0,
      categoryId: undefined,
      articleTitle: undefined,
    }
  },
  computed: {
    getFontSize() {
      switch (this.font_type) {
        case 'big':
          return '20px';
        case 'middle':
          return '18px';
        case 'small':
        default:
          return '16px';
      }
    }
  },
  async mounted() {
    this.id = this.$route.query.id
    await this.getData()

  },
  methods: {

    getData() {
      request.get(`/api/column/rest_article/${this.id}`).then((data) => {
        if (data.enclosure) {
          const arr1 = data.enclosure.split('/')
          const str1 = arr1[arr1.length - 1]
          const arr2 = str1.split('.')
          data.enclosureStr = arr2[0]
          data.enclosureType = data.enclosure.split('.')[1]
        }

        this.data = data
        this.categoryId = data.categoryId
        console.log(this.categoryId)
        this.articleTitle = data.title
        //@ts-ignore
        document.title = '同州天气'
        this.initWeixin()
        // document.title = this.data.title
      })
    },
    view(value: any) {
      const type = value.split('.')[1]
      if (type === 'png' || type === 'jpg' || type === 'jpeg' || type === 'mp4' || type === 'pdf') {
        let baseUrl = ''
        if (process.env.NODE_ENV == 'development') {
          baseUrl = 'https://tzwx.sxktqx.com'
        }
        window.location.href = `${baseUrl}/columnfiles${value}`
      } else {
        Toast.fail('暂不支持该格式')
      }
    },
    like(id: Number) {
      request.put(`/api/column/rest_article/${this.id}`).then((data) => {

        if (this.liked === 1) {
          return
        }
        Toast.success('已点赞')
        // @ts-ignore
        if (this.data.posid) {
          // @ts-ignore
          this.data.posid = Number(this.data.posid) + 1
        } else {
          // @ts-ignore
          this.data.posid = 1
        }
        // this.getData()
        this.liked = 1
      })
    },
    changeFontSize(type: string) {
      this.font_type = type
    },
    async initWeixin() {
      const url = window.location.href
      const timestamp = moment().valueOf()
      const nonceStr = 'tongzhouwechat'
      const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
      console.log('jsapiTicket', jsapiTicket)
      const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
      console.log('params', params)
      const signature = sha1(params)
      const obj = {
        appId: WECHAT_APPID,
        nonceStr: nonceStr,
        signature: signature,
        timestamp: timestamp,
      }

      let shareData = {
        title: WECAHT_NAME,
        desc: this.articleTitle,
        imgUrl: IMG_URL,
        link: url,
      };
      wxShare(obj, shareData);
    },
  },
  filters: {
    dtFormat(timestamp: number) {
      const time = moment(timestamp)
      return time.format('YYYY-MM-DD HH:mm:ss')
    },
  },
})
